import React, { useRef, useState } from "react";
import FileInput from "./FileInput";
import FileInputGallery from "./FileInputGallery";
import "./GlobalForm.css";
import NestedInput from "./NestedInput";
import NestedInputImage from "./NestedInputImage";
import NestedInputMultiple from "./NestedInputMultiple";
import SelectTag from "./SelectTag";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";
import TextInputObject from "./TextInputObject";
import Dropdown from "../shared/dropdown/Dropdown";
import FileInputBiss from "./FileInputBiss";
import TinyMCEEditor from "./RichTextEditorV2";
import LexicalEditor from "../lexical/RichTextEditorV1";

const currentLocation = window.location.href;

const GlobalForm = ({
  data,
  multipleData,
  nestedData,
  nestedGalleryData,
  multiDimensionalData,
  multiDimensionalDataText,
  multiDimensionalDataImage,
  multiDimensionalMultipleData,
  update,
  deleteBtn,
  updateBtn,
  helperFunction,
  nestedDataWithInput,
}) => {
  const [newData] = useState(data);
  const [editorMode, setEditorMode] = useState({});
  const lexicalContent = useRef({});

  const formRef = useRef();

  const jobStatusData = ["active", "expired", "hidden"];

  const handleLexicalChange = (name, value) => {
    lexicalContent.current[name] = value;
  };

  const toggleEditorMode = (name) => {
    setEditorMode((prev) => ({
      ...prev,
      [name]: prev[name] === "lexical" ? "tinymce" : "lexical",
    }));
  };

  const inputElement = (item, index) => {
    const { elementType } = item;
    if (elementType === "input") {
      return <TextInput key={index} item={item} />;
    } else if (elementType === "inputObject") {
      return <TextInputObject key={index} item={item} />;
    } else if (elementType === "textField") {
      return <TextAreaInput key={index} item={item} />;
    } else if (elementType === "file") {
      return <FileInput key={index} item={item} />;
    } else if (elementType === "fileBiss") {
      return <FileInputBiss key={index} item={item} />;
    } else if (elementType === "gFile") {
      return <FileInputGallery key={index} item={item} />;
    } else if (elementType === "nested") {
      return <NestedInput key={index} item={item} />;
    } else if (elementType === "nestedText") {
      return <NestedInput key={index} item={item} text={true} />;
    } else if (elementType === "nestedImage") {
      return <NestedInputImage key={index} item={item} />;
    } else if (elementType === "nestedMultiple") {
      return <NestedInputMultiple key={index} item={item} />;
    } else if (elementType === "select") {
      return <SelectTag key={index} item={item} />;
    } else if (elementType === "richTextEditor") {
      const mode = editorMode[item.name] || "lexical";
      return (
          <div key={index}>
            <div className="flex justify-end items-center gap-3 mb-2">
              <button
                type="button"
                onClick={() => toggleEditorMode(item.name)}
                className="text-xs border border-gray-300 rounded px-2 py-1 hover:bg-gray-100"
              >
                {mode === "lexical" ? "Switch to TinyMCE" : "Switch to Lexical"}
              </button>
            </div>
          {mode === "lexical" ? (
            <LexicalEditor
              key={`lexical-${item.name}`}
              item={item}
              onChange={(value) => handleLexicalChange(item.name, value)}
            />
          ) : (
            <TinyMCEEditor key={`tinymce-${item.name}`} item={item} />
          )}
        </div>
      );
    }
    else if (elementType === "richTextEditorV2") {
      return (
        <LexicalEditor
          key={index}
          item={item}
          onChange={(value) => handleLexicalChange(item.name, value)}
        />
      )
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const submitData = {};
    data?.map(
      (item) =>
      (submitData[item.name] = formRef.current[item.name]?.value
        ? formRef.current[item.name].type === "password"
          ? formRef.current[item.name]?.value
          : formRef.current[item.name]?.value?.trim()
        : formRef.current[item.name]?.src?.split("/")?.pop())
    );

    data?.map((item) => {
      let value;

      if (formRef.current[item.name]?.value !== undefined) {
        if (item.elementType === "richTextEditor") {
          const mode = editorMode[item.name] || "lexical";
          if (mode === "lexical") {
            value = lexicalContent.current[item.name] || "";
          } else {
            value =
              formRef.current[item.name]?.value?.trim() === "" ||
                formRef.current[item.name]?.value == null
                ? ""
                : formRef.current[item.name]?.value;
          }
          submitData[item.name] = value;
        }
      } else if (item.elementType === "richTextEditor" || item.elementType === "richTextEditorV2") {
        if (lexicalContent.current[item.name]) {
          submitData[item.name] = lexicalContent.current[item.name];
        }
      }
    });

    nestedData &&
      nestedData.map((item) => {
        const temp = [];
      });

    nestedGalleryData &&
      nestedGalleryData.map((item) => {
        const temp = [];

        const elements = formRef.current[item.name];
        const elementList = elements?.length ? [...elements] : [elements];

        elementList?.forEach((element, idx) => {
          if (!element) return;

          const src = element.getAttribute("src");
          const alt = element.getAttribute("alt");

          console.log('alt', element.value || src);
          temp.push({
            url: (element.value || src)?.split('/')?.pop(),
            imgId: idx + 1,
          });

        });
        console.log('temp', temp);

        submitData[item.name] = temp;
      });


    multiDimensionalData &&
      multiDimensionalData.map((item) => {
        const temp = [];
        formRef.current[item.name]?.length > 0
          ? formRef.current[item.name].forEach((element) => {
            temp.push([
              element.parentNode.children[0]?.value,
              element?.value,
            ]);
          })
          : temp.push([
            formRef.current[item.name].parentNode.children[0]?.value,
            formRef.current[item.name]?.value,
          ]);

        submitData[item.name] = temp;

      });

    multiDimensionalDataText &&
      multiDimensionalDataText.map((item) => {
        const temp = [];
        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
            temp.push([
              element.parentNode.children[0]?.value,
              element?.value,
            ]);
          })
          : temp.push([
            formRef.current[item.name].parentNode.children[0]?.value,
            formRef.current[item.name]?.value,
          ]);
        submitData[item.name] = temp;
      });

    multiDimensionalDataImage &&
      multiDimensionalDataImage.map((item) => {
        const temp = [];
        const tempImage = [];
        const tempLink = [];
        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
            const image = element.parentNode.children[1]?.src;
            const link = element?.value;
            image && tempImage.push(image);
            link && tempLink.push(link);
          })
          : temp.push([
            formRef.current[item.name].parentNode.children[1]?.value,
            formRef.current[item.name]?.value,
          ]);

        for (let i = 0; i < tempLink.length; i++) {
          temp.push([tempImage[i] ? tempImage[i] : "", tempLink[i]]);
        }
        submitData[item.name] = temp;
      });

    multiDimensionalMultipleData &&
      multiDimensionalMultipleData.map((item) => {
        const temp = [];
        const tempTitle = [];
        const tempParagraph = [];
        const tempImage = [];

        formRef.current[item.name].length
          ? formRef.current[item.name].forEach((element) => {
            const title = element.type === "text" ? element.value : "";
            const image = element.type === "file" ? element.src : "";
            const paragraph =
              element.type === "textarea" ? element.value : "";

            title && tempTitle.push(title);
            paragraph && tempParagraph.push(paragraph);
            image && tempImage.push(image);
          })
          : temp.push([
            formRef.current[item.name].parentNode.children[1]?.value,
            formRef.current[item.name]?.value,
          ]);

        for (let i = 0; i < tempTitle.length; i++) {
          temp.push({
            title: tempTitle[i],
            paragraph: tempParagraph[i],
            image: tempImage[i] ? tempImage[i] : "",
          });
        }
        submitData[item.name] = temp;
      });
    update(submitData);
  };

  return (
    <div className="container mx-auto lg:p-8 py-6 md:px-5 ">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="grid grid-cols-1   xl:grid-cols-2 justify-items-center gap-8 gap-y-4 pb-8">
          {newData.map((item, index) => (
            // <div
            //   key={index}
            //   className="w-full bg-[#f9f9f9] shadow-sm  rounded-md p-4 border border-gray-200"
            // >
            //   {inputElement(item, index)}
            // </div>
            <div
              key={index}
              className={`w-full bg-[#f9f9f9] shadow-sm rounded-md p-4 border border-gray-200 ${item.elementType === "richTextEditor" ||
                item.elementType === "richTextEditorV2" ? "xl:col-span-2" : ""
                }`}
            >
              {inputElement(item, index)}
            </div>
          ))}
        </div>

        <div className="flex justify-end pt-4 gap-4 lg:gap-8">
          <button
            type="submit"
            className="btn btnW7ide border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:border-[#DB0029] hover:bg-[#DB0029] hover:shadow-md px-5 lg:px-10 py-2.5 rounded-xl transition duration-150"
          >
            {updateBtn ? "Update" : "Submit"}
          </button>
          {deleteBtn && (
            <button
              type="button"
              onClick={helperFunction}
              className="btn btnW7ide border-2 text-red-500 font-bold border-red-500 hover:text-white hover:border-red-500 hover:bg-red-500 hover:shadow-md px-5 lg:px-10 py-2.5 rounded-xl transition duration-150"
            >
              Delete
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default GlobalForm;
